import { render, staticRenderFns } from "./Doppelleu.vue?vue&type=template&id=cd4a418e&scoped=true"
import script from "./Doppelleu.vue?vue&type=script&lang=js"
export * from "./Doppelleu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4a418e",
  null
  
)

export default component.exports